import { useMutation } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type MutationConfig } from 'src/lib/react-query';
import { type GeneralSmartParkError } from 'src/types';
import { formatResourcePath } from 'src/utils/regex';

import type { AdditionalServices } from 'src/features/parkingManagement/types/additionalServices';

export type CreateAdditionalServicesFnType = typeof createAdditionalServices;

const RESOURCE = '/parkings/:parkingId/additional-service/';

export type CreateAdditionalServicesType = Omit<AdditionalServices, 'id' | 'tax_amount' | 'price'>;
export type DTO = {
    parkingId: string;
};

const createAdditionalServices = ({ parkingId, ...data }: DTO): Promise<CreateAdditionalServicesType> => {
    return axios.post(formatResourcePath(RESOURCE, { parkingId }), data);
};

interface UseCreateAdditionalServicesOptions
    extends MutationConfig<CreateAdditionalServicesFnType, GeneralSmartParkError> {}

export const useCreateAdditionalServices = (options: UseCreateAdditionalServicesOptions) =>
    useMutation({
        mutationFn: createAdditionalServices,
        ...options,
    });
